import { render, staticRenderFns } from "./dark-web.html?vue&type=template&id=11974531&scoped=true&"
import script from "./dark-web.js?vue&type=script&lang=js&"
export * from "./dark-web.js?vue&type=script&lang=js&"
import style0 from "./dark-web.scss?vue&type=style&index=0&id=11974531&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11974531",
  null
  
)

export default component.exports